import {FC} from 'react';
import {MiddleTopBarUnitManage} from '../../common/MiddleTopBarUnitManage';
import { DocumentsPerProcess } from './DocumentsPerProcess';
import { IDocumentsPerProcessProps } from './IDocumentsPerProcessProps';
import { HeadingWithDecoration } from '../../common/HeadingWithDecoration';

export const DocumentsPerProcessUnit: FC<IDocumentsPerProcessProps> = ({unitId}) => (
  <main className={`noPaddingTop`}>
    <MiddleTopBarUnitManage notUseHelmet unitId={unitId} active={'documentsPerProcess'} />
    <HeadingWithDecoration text="Documents per Process" />
    <DocumentsPerProcess unitId={unitId} />
  </main>
);
